/**
 * Pill dots for horizontal strips: [data-hp-strip-root] > [data-hp-strip-scroll],
 * slides marked [data-hp-strip-item], dots [data-hp-strip-dot][data-hp-strip-index].
 */
(function () {
  function slideEls(sc) {
    var list = [].slice.call(sc.querySelectorAll('[data-hp-strip-item]'));
    return list.filter(function (el) {
      return !el.hasAttribute('data-hp-strip-spacer');
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-hp-strip-ready')) return;
    var sc = root.querySelector('[data-hp-strip-scroll]');
    if (!sc) return;
    var dots = [].slice.call(root.querySelectorAll('[data-hp-strip-dot]'));
    if (dots.length < 2) return;

    root.setAttribute('data-hp-strip-ready', '1');

    function setActive(i) {
      dots.forEach(function (d, j) {
        if (j === i) d.classList.add('is-active');
        else d.classList.remove('is-active');
      });
    }

    function nearestIndex() {
      var slides = slideEls(sc);
      if (!slides.length) return 0;
      var rect = sc.getBoundingClientRect();
      var mid = rect.left + rect.width * 0.38;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (el, i) {
        var r = el.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var dist = Math.abs(c - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    var t;
    sc.addEventListener(
      'scroll',
      function () {
        clearTimeout(t);
        t = setTimeout(function () {
          setActive(nearestIndex());
        }, 48);
      },
      { passive: true }
    );

    dots.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-hp-strip-index'), 10) || 0;
        var slides = slideEls(sc);
        var target = slides[idx];
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });

    setActive(nearestIndex());
  }

  function run() {
    [].slice.call(document.querySelectorAll('[data-hp-strip-root]')).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
